import './page/acris-faq-index';
import './acris-settings-item.scss';

const { Module } = Shopware;

Module.register('acris-faq-list', {
    type: 'plugin',
    name: 'AcrisFaq',
    title: 'acris-faq-list.general.mainMenuItemGeneral',
    description: 'acris-faq-list.general.descriptionTextModule',
    version: '1.0.0',
    targetVersion: '1.0.0',
    color: '#a6c836',
    icon: 'regular-question-circle',

    routes: {
        index: {
            component: 'acris-faq-index',
            path: 'index',
            icon: 'regular-question-circle',
            meta: {
                parentPath: 'sw.settings.index.plugins'
            }
        }
    },

    navigation: [{
        id: 'acris-faq-list-index',
        label: 'acris-faq-list.general.mainMenuItemGeneral',
        color: '#a6c836',
        icon: 'regular-question-circle',
        path: 'acris.faq.list.index',
        position: 1000,
        parent: 'sw-catalogue'
    }],

    settingsItem: [
        {
            name: 'acris-faq-list-index',
            to: 'acris.faq.list.index',
            label: 'acris-faq-list.general.mainMenuItemGeneral',
            group: 'plugins',
            icon: 'regular-question-circle'
        }
    ]
});
